import { GET_SINGLE_SHOP_OUTGOING_PAYMENTS } from "../constants/endpoints";
import axiosClient from "./axios";

class allOutgoingPaymentsService {
  static async fetchAllOutgoingPayments(
    shopId: any,
    page: number,
    limit: number,
    startDate: string,
    endDate: string,
    externalOrderId: string,
    settlementIds: string[],
    created_at: string,
    updated_at: string
  ) {
    const url = GET_SINGLE_SHOP_OUTGOING_PAYMENTS.replace("{shopId}", shopId);
    const filters = {
      startDate: startDate !== null ? startDate : undefined,
      endDate: endDate !== null ? endDate : undefined,
      externalOrderId: externalOrderId !== null ? externalOrderId : undefined,
      settlementIds: settlementIds !== null ? settlementIds : undefined,
    };
    const sort = {
      created_at: created_at !== null ? created_at : undefined,
      updated_at: updated_at !== null ? updated_at : undefined,
    };
    const response = await axiosClient.post(url, {
      page: page,
      limit: limit,
      filters: filters,
      sort: sort,
    });
    return response;
  }
}

export default allOutgoingPaymentsService;
